module.exports = __webpack_public_path__ + "img/2c2p.b9347a08.png";